<template>
  <div class="popup-main">
    <el-dialog
      title="开送货单"
      width="1400px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <div>
        <e-form
          ref="refForm"
          :config="formConfig"
          :column="formColumn"
          :rules="formRules"
          :data.sync="selfDetail.form_data"
        />
        <vxe-grid
          ref="refTable"
          :min-height="tableConfig.minHeight"
          :toolbar-config="tableConfig.toolbarConfig"
          :edit-config="tableConfig.editConfig"
          :row-config="tableConfig.rowConfig"
          :mouse-config="tableConfig.mouseConfig"
          :keyboard-config="tableConfig.keyboardConfig"
          :columns="tableColumn"
          :data="selfDetail.goods_list"
          :show-footer="!!selfDetail.goods_list.length"
          :footer-method="footerMethod"
        >
          <!-- slot_default -->
          <template #default_operate="{ rowIndex }">
            <el-link type="success" @click="itemAdd(rowIndex)">增行</el-link>
            <el-link type="danger" @click="itemDelete(rowIndex)">删行</el-link>
          </template>

          <!-- slot_edit -->
          <template #edit_goods_name="{ row }">
            <el-input v-model="row.goods_name" size="mini" clearable />
          </template>
          <template #edit_goods_spec="{ row }">
            <el-input v-model="row.goods_spec" size="mini" clearable />
          </template>
          <template #edit_goods_unit="{ row }">
            <el-input v-model="row.goods_unit" size="mini" clearable />
          </template>
          <template #edit_goods_count="{ row }">
            <el-input
              v-model="row.goods_count"
              type="number"
              size="mini"
              clearable
              @blur="countsBlur(row)"
            />
          </template>
          <template #edit_goods_price="{ row }">
            <el-input
              v-model="row.goods_price"
              type="number"
              size="mini"
              clearable
              @blur="countsBlur(row)"
            />
          </template>
          <template #edit_goods_remark="{ row }">
            <el-input v-model="row.goods_remark" size="mini" clearable />
          </template>
        </vxe-grid>
      </div>
      <div slot="footer">
        <div class="flex flex-y-center flex-x-between">
          <div class="flex flex-y-center">
            <el-button size="mini" type="default" @click="popupChooseOrder">
              选择销售订单
            </el-button>
          </div>
          <div class="flex flex-y-center">
            <el-button size="mini" @click="popupCancel">取消</el-button>
            <el-button size="mini" type="primary" @click="popupPush(false)">提交</el-button>
            <el-button
              v-if="this.selfDetail.form_data.delivery_status"
              size="mini"
              type="primary"
              @click="popupPush(true)"
            >
              打印预览
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 弹窗-选择销售订单 -->
    <PopupChooseOrder
      v-if="isShowPopupChooseOrder"
      :show.sync="isShowPopupChooseOrder"
      @success="updateUpdateChooseOrder"
    />
  </div>
</template>

<script>
export default {
  components: {
    PopupChooseOrder: () => import('./popup-choose-order')
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    isAdmin: {
      type: Boolean,
      required: true
    },
    detail: {
      type: Object,
      default: () => {
        return null
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selfShow: false,
      selfDetail: {
        form_data: {
          delivery_id: '', // 送货单id
          delivery_code: '', // 送货单号
          delivery_date: this.$XEUtils.toDateString(this.$XEUtils.now(), 'yyyy-MM-dd'), // 发货日期
          delivery_status: false, // 审核状态
          customer_name: '', // 客户名称
          customer_uuid: '', // 客户uuid
          saler_name: '', // 业务员
          saler_id: '', // 业务员id
          saler_company_name: '' // 开单公司
        },
        goods_list: []
      },
      defaultObj: {
        goods_id: '',
        goods_name: '',
        goods_spec: '',
        goods_unit: '',
        goods_count: '',
        goods_price: '',
        goods_amount: '',
        goods_remark: ''
      },
      customerList: [],
      customerKeyword: '',
      formConfig: {
        inline: true,
        width: '200px'
      },
      formColumn: [
        {
          type: 'select',
          title: '客户名称',
          field: 'customer_uuid',
          width: '275px',
          options: [],
          remote: true,
          remoteMethod: (val) => {
            this.customerKeyword = val
            this.getCustomerList(true)
          }
        },
        {
          type: 'text',
          title: '送货单号',
          field: 'delivery_code',
          placeholder: '自动生成',
          disabled: true
        },
        {
          type: 'text',
          title: '业务员',
          field: 'saler_name',
          disabled: true
        },
        {
          type: 'select',
          title: '开单公司',
          field: 'saler_company_name',
          width: '275px',
          options: this.$constant.companyList
        },
        {
          type: 'date',
          title: '发货日期',
          field: 'delivery_date',
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd'
        },
        {
          type: 'switch',
          title: '审核状态',
          field: 'delivery_status',
          hide: !this.isAdmin
        }
      ],
      formRules: {
        customer_uuid: [{ required: true, message: '请选择客户名称' }],
        saler_company_name: [{ required: true, message: '请选择开单公司' }],
        delivery_date: [{ required: true, message: '请选择发货日期' }]
      },
      tableColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          title: '品名',
          field: 'goods_name',
          slots: { edit: 'edit_goods_name' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '规格',
          field: 'goods_spec',
          slots: { edit: 'edit_goods_spec' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '单位',
          field: 'goods_unit',
          slots: { edit: 'edit_goods_unit' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '数量',
          field: 'goods_count',
          slots: { edit: 'edit_goods_count' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '单价(元)',
          field: 'goods_price',
          slots: { edit: 'edit_goods_price' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '金额(元)',
          field: 'goods_amount'
        },
        {
          title: '备注',
          field: 'goods_remark',
          slots: { edit: 'edit_goods_remark' },
          editRender: { autofocus: '.el-input__inner' }
        },
        { title: '操作', slots: { default: 'default_operate' } }
      ],
      isShowPopupChooseOrder: false
    }
  },
  computed: {
    // 表格配置合并
    tableConfig() {
      let disabled = this.disabled
      let obj = {
        editConfig: {
          beforeEditMethod() {
            return !disabled
          }
        },
        keyboardConfig: {
          isEdit: !disabled
        }
      }
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig, obj)
      return result
    },
    selfAccountData() {
      let result = this.$store.getters.getLoginAccount
      return result
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    if (this.detail) {
      this.selfDetail = this.$util.deepCopy(this.detail)
    } else {
      this.itemAdd()
      this.selfDetail.form_data.saler_name = this.selfAccountData.nick_name
      this.selfDetail.form_data.saler_id = this.selfAccountData.id
    }
    this.getCustomerList()
  },
  methods: {
    // 获取客户列表
    getCustomerList() {
      this.$api({
        method: 'post',
        url: '/admin/customers/search',
        data: {
          keyword: this.customerKeyword,
          pageSize: 200
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = res.data.page.list.map((item) => {
            return {
              key: item.customer_name,
              val: item.company_uuid
            }
          })
          this.customerList = result
          this.formColumn.forEach((item) => {
            if (item.field === 'customer_uuid')
              item.options = this.$util.deepCopy(this.customerList)
          })

          // 用于客户编辑保存成功
          this.customerList.forEach((item) => {
            if (item.val === this.selfDetail.form_data.customer_uuid) {
              this.selfDetail.form_data.customer_name = item.key
            }
          })
        }
      })
    },
    // 项-新增
    itemAdd() {
      let result = this.$util.deepCopy(this.defaultObj)
      this.selfDetail.goods_list.push(result)
    },
    // 项-删除
    async itemDelete(index) {
      if (this.selfDetail.goods_list.length > 1) {
        this.selfDetail.goods_list.splice(index, 1)
      } else {
        this.selfDetail.goods_list[index].cai_zhi = ''
      }
    },
    // 表格底部
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (['goods_count', 'goods_amount'].includes(column.field)) {
            return this.$util.listFieldTotal(data, column.field)
          }
        })
      ]
    },
    // 送货数量-失焦
    countsBlur(row) {
      row.goods_amount = this.$XEUtils.multiply(row.goods_price, row.goods_count)
    },
    // 弹窗-选择销售订单
    popupChooseOrder() {
      this.isShowPopupChooseOrder = true
    },
    // 弹窗-更新选择销售订单
    updateUpdateChooseOrder(row) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/songHuo/buildSongHuoBill2',
        params: {
          id: row.bill_id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          if (!this.selfDetail.form_data.customer_uuid) {
            this.selfDetail.form_data.customer_name = res.data.formData.company_name
            this.selfDetail.form_data.customer_uuid = res.data.formData.company_uuid
          }
          if (!this.selfDetail.form_data.saler_company_name) {
            this.selfDetail.form_data.saler_company_name = res.data.formData.saler_company_name
          }
          let oldList = this.$util.deepCopy(this.selfDetail.goods_list)
          this.selfDetail.goods_list = oldList.filter((item) => {
            let result =
              item.goods_id ||
              item.goods_name ||
              item.goods_spec ||
              item.goods_unit ||
              item.goods_count ||
              item.goods_price ||
              item.goods_amount ||
              item.goods_remark
            return result // 过滤全部字段为空的项
          })
          res.data.list.forEach((item) => {
            let obj = {
              goods_id: '',
              goods_name: item.craft,
              goods_spec: item.specification,
              goods_unit: item.unit,
              goods_count: item.stock_counts,
              goods_price: item.stock_price,
              goods_amount: item.stock_amount,
              goods_remark: item.stock_remark
            }
            this.selfDetail.goods_list.push(obj)
          })
        }
      })
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupPush(isPushAndPrint) {
      this.$refs.refForm.$refs.refForm.validate((valid) => {
        if (valid) {
          this.customerList.forEach((item) => {
            if (item.val === this.selfDetail.form_data.customer_uuid)
              this.selfDetail.form_data.customer_name = item.key
          })
          if (!this.selfDetail.form_data.delivery_date) {
            this.$message.error('请选择发货日期')
            return
          }
          this.$api({
            method: 'post',
            url: '/admin/gcvip/songHuo2/saveOrUpdate',
            data: this.selfDetail
          })
            .then((res) => {
              if (res.data.state === 'ok') {
                this.popupCancel()
                this.$emit('success')
                this.$message.success('保存成功')
                if (isPushAndPrint) this.popupPrint(res.data.delivery_id)
              }
            })
            .catch((error) => {
              this.$message.error(error)
            })
        }
      })
    },
    // 项-打印
    popupPrint(id) {
      window.open(`/sale/delivery/print?id=${id}`, '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
